import MainMarketDescriptionMapper from './main-market-description-mapper';
import MainOutcomeDescriptionModel from '../main-outcome-description/main-outcome-description-model';
import MarketSpecifierModel from '../market-specifier/market-specifier-model';

const MainMarketDescriptionModel = {
    mapper: MainMarketDescriptionMapper,

    id: {
        type: String,
    },

    label: {
        type: String,
    },

    marketRefId: {
        type: String,
    },

    name: {
        type: String,
    },

    outcomes: {
        model: MainOutcomeDescriptionModel,
        type: Array,
    },

    specifiers: {
        model: MarketSpecifierModel,
        type: Array,
    },

    sportTypeId: {
        type: String,
    },
};

export default MainMarketDescriptionModel;
